export default __webpack_public_path__ + "static/media/aj2.8495120f.png";